import { ClientFactories, Store } from "bernie-core";
import { ClientLogger } from "bernie-client";
import { ShortlistStore } from "./ShortlistStore";
import { UIPageStore } from "./UIPageStore";
import { HotelsStore } from "./HotelsStore";
import { ThemeSelectorStore } from "./ThemeSelectorStore";
import { BexApiService } from "services/BexApiService";
import { ClientThumborStore } from "./thumbor/ClientThumborStore";
import { ClientStaticMapStore } from "./staticMap/ClientStaticMapStore";
import { DXStore } from "./DXStore";
import { NOOP_LOGGER, Logger } from "bernie-logger";
import { CookiesStore } from "src/stores/CookiesStore";
import { AdvertisingStore } from "./AdvertisingStore";
import { ClientMarkdownStore } from "./markdownHandler/ClientMarkdownStore";
import { ClientWizardStateStore } from "./wizard/ClientWizardStateStore";
import { alterClientStores } from "bernie-alter";
import { ContextInput } from "__generated__/api";
import { CompositionStore } from "stores/CompositionStore";
import { DestinationSuggestionsStore } from "stores/DestinationSuggestionsStore";
import { ClientFlexViewModelStore } from "stores/flexViewModel/ClientFlexViewModelStore";
import { ClientPoiStore } from "./poiStore/ClientPoiStore";
import { TCSService } from "../services/TCSService";
import { TemplateStore } from "stores/TemplateStore";
import { RecentlyViewedStore } from "./RecentlyViewedStore";
import { MerchCampaignsStore } from "./MerchCampaignsStore";
import { ClientChatbotStore } from "./chatbotStore/ClientChatbotStore";

export const buildBexApiServiceWithHeaders = (bexApiContext: ContextInput, logger: Logger) => {
  return new BexApiService("", logger, {
    "Device-User-Agent-ID": bexApiContext.identity.duaid,
  });
};

export const stores: ClientFactories = {
  flexViewModel: (): Store =>
    new ClientFlexViewModelStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.viewmodel")),
  shortlist: (): Store => new ShortlistStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.shortlist")),
  uiPage: (): Store => new UIPageStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.uiPage")),
  thumbor: (): Store => new ClientThumborStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.thumbor")),
  markdown: (): Store => new ClientMarkdownStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.markdown")),
  cookies: (): Store => new CookiesStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.cookies")),
  hotels: ({ bexApiContext }): Store => {
    const logger = ClientLogger.getLoggerWithIdentifier("blossom.store.hotels");
    const bexApiService = buildBexApiServiceWithHeaders(bexApiContext, logger);

    return new HotelsStore({}, logger, bexApiService);
  },
  recentlyViewed: ({ bexApiContext }): Store => {
    const logger = ClientLogger.getLoggerWithIdentifier("blossom.store.recentlyViewed");
    const bexApiService = buildBexApiServiceWithHeaders(bexApiContext, logger);

    return new RecentlyViewedStore({}, logger, bexApiService);
  },
  staticMap: (): Store => new ClientStaticMapStore({}, NOOP_LOGGER),
  dx: (): Store => new DXStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.dx")),
  advertising: (): AdvertisingStore =>
    new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.advertising")),
  destinationSuggestions: (): Store =>
    new DestinationSuggestionsStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.destinationSuggestions")),
  wizardState: (): Store =>
    new ClientWizardStateStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.wizardState")),
  poi: (): Store => {
    const logger = ClientLogger.getLoggerWithIdentifier("blossom.store.poi");
    const tcsService = new TCSService("/blossomTcs");

    return new ClientPoiStore({}, tcsService, logger);
  },
  merchCampaigns: ({ bexApiContext }): Store => {
    const logger = ClientLogger.getLoggerWithIdentifier("blossom.store.merchCampaigns");
    const bexApiService = buildBexApiServiceWithHeaders(bexApiContext, logger);

    return new MerchCampaignsStore({}, logger, bexApiService);
  },

  ...alterClientStores,
  compositionStore: () => new CompositionStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.composition")),
  templateStore: (): Store => new TemplateStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.template")),

  themeSelectorStore: () =>
    new ThemeSelectorStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.themeSelectorStore")),
  chatbot: (): Store => new ClientChatbotStore({}, ClientLogger.getLoggerWithIdentifier("blossom.store.chatbotStore")),
};
